import { TextOnImageCol } from '@definitions/types/storyblokTypes'

import { createStoryblokAsset } from '../../../../../__mocks__/storyblok/createStoryblokAsset'
import { createStoryblokMultilink } from '../../../../../__mocks__/storyblok/createStoryblokMultilink'
import { createStoryblokRichtext } from '../../../../../__mocks__/storyblok/createStoryblokRichtext'

/**
 * Creates a mock TextOnImageCol
 * @param overrides - Partial fields to override defaults
 * @returns Complete TextOnImageCol mock
 */
export function createTextOnImageCol(
  overrides: Partial<TextOnImageCol> = {}
): TextOnImageCol {
  return {
    _uid: '7236e357-76c6-45fe-bab9-e4d1c7c8ecc6',
    link: createStoryblokMultilink({
      id: 'a9c26fc2-0022-4313-8963-c083c435d947',
      linktype: 'story',
      cached_url: 'sunpoint/braeune/hauttypen-test',
    }),
    image: createStoryblokAsset({
      id: 10944283,
      alt: 'test',
      title: 'test',
      focus: '452x149:453x150',
      filename:
        'https://a.storyblok.com/f/235453/592x322/404a45832c/shutterstock_2127851798-1.png',
      src: 'https://a.storyblok.com/f/235453/592x322/404a45832c/shutterstock_2127851798-1.png',
      width: 592,
      height: 322,
      aspect_ratio: 1.84,
      content_type: 'image/png',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    content: createStoryblokRichtext('Erfahre, welcher Hauttyp du bist'),
    headline: 'Hauttypen-Test\n',
    linkName: 'Zum Hauttypen-Test',
    component: 'text-on-image-col',
    logoImage: createStoryblokAsset({
      id: 123,
      alt: 'null',
      title: 'null',
      focus: 'null',
      filename: '',
      copyright: 'null',
      updated_at: '2024-01-01T00:00:00.000Z',
    }),
    rightAlign: false,
    _editable:
      '<!--#storyblok#{"name": "text-on-image-col", "space": "235453", "uid": "7236e357-76c6-45fe-bab9-e4d1c7c8ecc6", "id": "322564270"}-->',
    ...overrides,
  }
}
